import "core-js/modules/es.array.concat.js";
import _toConsumableArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useEcommerceProcesses } from './use-ecommerce-processes';
import { useTrackingEvents } from './use-tracking-events';
export function useTimeline() {
  var trackingEvents = useTrackingEvents();
  var processEvents = useEcommerceProcesses();
  return [].concat(_toConsumableArray(trackingEvents), _toConsumableArray(processEvents));
}